import { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { AlertBanner } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { CallingBannerStore } from 'entities/Compliance/ui/CallingBanner/store/callingBannerStore'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const CallingBanner = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new CallingBannerStore(entities))

  useEffect(() => {
    store.init()
  }, [])

  if (!uiStore.location) return null
  if (!store.config) return null

  return <AlertBanner ariaLabel={'CallingRejected'} {...store.config} />
})
